import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {IAchievementQuery} from "../../models/achievement/query";
import {IAchievement, IAchievementDetails} from "../../models/achievement/response";
import {ICreateAchievement, IUpdateAchievement} from "../../models/achievement/request";

class AchievementService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllAchievements = (query: IAchievementQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<IAchievement>>({
            path: `/achievements`,
            method: "GET",
            query,
            ...params,
        });

    getAchievement = (id: number, params?: RequestParams) =>
        this.http.request<IAchievementDetails>({
            path: `/achievements/${id}`,
            method: "GET",
            ...params,
        });

    createAchievement = (data: ICreateAchievement, params?: RequestParams) =>
        this.http.request<IAchievement>({
            path: "/achievements",
            method: "POST",
            body: data,
            ...params,
        });

    updateAchievement = (id: number, data: IUpdateAchievement, params?: RequestParams) =>
        this.http.request<IAchievement>({
            path: `/achievements/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteAchievement = (id: number, params?: RequestParams) =>
        this.http.request<IAchievement>({
            path: `/achievements/${id}`,
            method: "DELETE",
            ...params,
        });
}

export default AchievementService;